import { useContext } from 'react';
import { PresetContext } from '@/contexts/PresetContext';
import { invariant } from '@/utils/invariant';

export function usePresets() {
  return invariant(useContext(PresetContext), 'usePresets must be used inside <PresetProvider>.');
}
